import React, { ChangeEvent } from "react";
import gql from "graphql-tag";
import { useQuery } from "@apollo/client";
import { useLocaleFormatter } from "@ct-react/locale";
import { AccommodationType } from "@shared/models/article";
import "./selectors.scss";

const OBJECT_TYPES_DATA = gql`
  query ObjectTypes($type: AccommodationType) {
    types: searchableAccommodationObjectTypes(accommodationType: $type) { id name }
  }
`;

type Props = {
  type: AccommodationType;
  value?: number[];
  onChange?: (value?: number[]) => void;
}

export const SearchItemSelectorObjectType = (
  {
    type,
    value = [],
    onChange = () => void 0
  }: Props) => {

  const { transLib } = useLocaleFormatter();

  const { data } = useQuery(OBJECT_TYPES_DATA, { variables: { type } });

  const onValueChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = [
      ...value!.filter(val => val !== +e.target.value),
      ...(e.target.checked ? [ +e.target.value] : [])
    ];
    onChange(newValue.length > 0 ? newValue : undefined);
  }

  if (!data || data.types.length === 0)
    return null;

  return data.types.map((type: any, i: number) => (
    <label key={i} htmlFor={type.name}>
      <input type="checkbox"
             id={type.name}
             value={type.id}
             checked={value.includes(type.id)}
             onChange={onValueChange} />
      {transLib.match("objectTypes", type.id)}
    </label>));

}

export default SearchItemSelectorObjectType;
